import { Scrollbars } from 'react-custom-scrollbars-2';
import { HiX } from 'react-icons/hi';
import { TbLayout2, TbMessageDots, TbSitemap, TbHelp } from 'react-icons/tb';
import { MdModelTraining } from 'react-icons/md';
import { renderThumb, renderTrack, renderView } from '../scrollbar/Scrollbar';
import SidebarCard from './SidebarCard';
import Card from '../card';
import { NavLink } from 'react-router-dom';
const SidebarHorizon = ({ open, onClose }) => {
  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 min-h-full transition-all md:!z-50 lg:!z-50 xl:!z-0 xl:block
        ${open ? '' : '-translate-x-full'}`}
    >
      <Card
        extra={`w-[300px] ml-4 sm:mr-4 sm:my-4 h-[96.5vh] !rounded-[20px]`}
      >
        <Scrollbars
          autoHide
          renderTrackVertical={renderTrack}
          renderThumbVertical={renderThumb}
          renderView={renderView}
        >
          <div className="flex h-full flex-col justify-between">
            <div>
              <span
                className="absolute top-4 right-4 block cursor-pointer xl:hidden"
                onClick={onClose}
              >
                <HiX />
              </span>

              <div className="py-2 px-12 text-center">
                <NavLink to="/admin/dashboard">
                  <img src={process.env.REACT_APP_LOGO} alt="ShopAgent Logo" className="text-3xl font-bold uppercase no-underline dark:text-white" />
                </NavLink>
              </div>
              <div className="h-px bg-gray-200 dark:bg-gray-600" />

              {/* Nav item */}
              <div className="mt-10 px-12">
                <NavLink
                  to="/admin/dashboard"
                  className={({ isActive }) =>
                    `flex text-gray-900 dark:text-whiteColor hover:text-tertiary  no-underline mb-3 items-center ${isActive ? 'opacity-100' : 'opacity-60'
                    }`
                  }
                >
                  <TbLayout2 size={24} />
                  <span className="text-xl ml-2">Dashboard</span>
                </NavLink>

                <NavLink
                  to="/admin/widgets"
                  className={({ isActive }) =>
                    `flex text-gray-900 dark:text-whiteColor hover:text-tertiary no-underline mb-3 items-center ${isActive ? 'opacity-100' : 'opacity-60'
                    }`
                  }
                >
                  <TbSitemap size={24} />
                  <span className="text-xl ml-2">Widgets</span>
                </NavLink>

                <NavLink
                  to="/admin/chat"
                  className={({ isActive }) =>
                    `flex text-gray-900 dark:text-whiteColor hover:text-tertiary no-underline mb-3 items-center ${isActive ? 'opacity-100' : 'opacity-60'
                    }`
                  }
                >
                  <TbMessageDots size={24} />
                  <span className="text-xl ml-2">Live Chat</span>
                </NavLink>

                <NavLink
                  to="/admin/train"
                  className={({ isActive }) =>
                    `flex text-gray-900 dark:text-whiteColor hover:text-tertiary no-underline mb-3 items-center ${isActive ? 'opacity-100' : 'opacity-60'
                    }`
                  }
                >
                  <MdModelTraining size={24} />
                  <span className="text-xl ml-2">Agent Training</span>
                </NavLink>

                {/* <NavLink
                  to="/admin/about"
                  className={({ isActive }) =>
                    `flex text-gray-900 dark:text-whiteColor hover:text-tertiary no-underline mb-3 items-center ${
                      isActive ? 'opacity-100' : 'opacity-60'
                    }`
                  }
                >
                  <TbHelp size={24} />
                  <span className="text-xl ml-2">About</span>
                </NavLink> */}
              </div>
            </div>

            <div className="mt-[28px] mb-[150px] flex justify-center">
              <SidebarCard />
            </div>
          </div>
        </Scrollbars>
      </Card>
    </div>
  );
};

export default SidebarHorizon;
